<template>
  <Loader
    v-model="data"
    :url="getStatsUrl ()"
  >
    <div
      slot="result"
      v-if="data"
      class="Statistics container"
    >
      <Tabbed :tabs="getTabs ()">
        <div
          v-for="(counter, key) in data.types.grouped"
          :slot="capitalize (key)"
        >
          <Panel>
            <template slot="header">
              {{ capitalize (key) }}
            </template>

            <template slot="body">
              <BarChart
                :data="counter.buckets"

                :series="{
                  wins: {
                    colour: 'green'
                  },

                  losses: {
                    colour: 'red'
                  }
                }"

                :stacked="true"

                sort="wins"
              ></BarChart>
            </template>
          </Panel>
        </div>

        <div
          v-for="(counter, key) in data.types.range"
          :slot="capitalize (key)"
        >
          <Panel>
            <template slot="header">
              {{ capitalize (key) }}
            </template>

            <template slot="body">
              <!-- <Tabbed :tabs="[ 'Histogram', 'Averages' ]" :orient="'horizontal'">
                <div slot="Histogram">
                  <Histogram
                    :data="counter.buckets"
                    :title="capitalize (key)"
                  ></Histogram>
                </div>

                <div slot="Averages">
                  <LineChart
                    :labels="{
                      x: 'Period',
                      y: capitalize (key),
                      uX: '',
                      uY: ''
                    }"
                    :series="timelineToSeries (key, counter)"
                    curve="curveLinear"
                    :formatX="timelineFormatX"
                  ></LineChart>
                </div>
              </Tabbed> -->

              <div slot="Histogram">
                  <Histogram
                    :data="counter.buckets"
                    :title="capitalize (key)"
                  ></Histogram>
                </div>


              <div class="my-4 text-center text-medium yellow">
                Average: {{ round (counter.average.value, 2) }}
              </div>

              <div class="Overview-Extrema row" v-if="counter.cardinality > 0">
                <div class="col-md-6" v-for="(extrema, label) in { highest: counter.highest, lowest: counter.lowest }">
                  <div class="text-center text-medium mb10">{{ capitalize (label) }}</div>
                  <Table>
                    <Row header>
                      <Cell>Value</Cell>
                      <Cell>Latest</Cell>
                    </Row>
                    <Row
                      v-for="(bucket, rank) in extrema"
                      :to="{ name: 'gameProfile', params: { id: bucket.from.replayId } }"
                    >
                      <Cell>
                        {{ round (bucket.value, 2) }}
                        <Bar
                          width="100px"
                          :fill="relative ('value', bucket, extrema)"
                        ></Bar>
                      </Cell>
                      <Cell>
                        <strong>{{ battleTag (bucket.from.player) }}</strong>
                        <!-- <ul class="list-unstyled row">
                          <li
                            v-for="value in bucket.values"
                            class="list-item col-6"
                          >
                            {{ value }}
                          </li>
                        </ul> -->
                      </Cell>
                    </Row>
                  </Table>
                </div>
              </div>
            </template>
          </Panel>
        </div>
      </Tabbed>
    </div>
  </Loader>
</template>

<script>
  import * as d3 from 'd3';
  import * as moment from 'moment';
  import Panel   from '@/legacy/components/widgets/Panel';
  import Tabbed  from '@/legacy/components/widgets/Tabbed';
  import BarChart from '@/legacy/components/widgets/BarChart';
  import LineChart from '@/legacy/components/widgets/LineChart';
  import Histogram from '@/legacy/components/widgets/Histogram';
  // import Table from '@/legacy/components/widgets/Table.vue';
  import Bar from '@/legacy/components/widgets/Bar';
  import Loader from '@/legacy/components/widgets/Loader';

  import { Table, Row, Cell }  from '@/legacy/components/widgets/Table';

  import { relative, forEach, inArray } from '@/legacy/lib//util';
  import { capitalize, battleTag } from '@/legacy/lib//template';
  import { round } from '@/legacy/lib//math';

  export default {
    components: {
      Panel,
      Tabbed,
      BarChart,
      LineChart,
      Histogram,
      Bar,
      Loader,
      Table,
      Row,
      Cell
    },

    props: {
      id: {
        type: Number
      }
    },

    data () {
      return {
        data: null
      }
    },

    methods: {
      capitalize,
      relative,
      round,
      battleTag,

      getStatsUrl () {
         return `/stats/${this.id}`;
      },

      getTabs () {
        let tabs = [];

        tabs = tabs.concat (Object.keys (this.data.types.grouped || []));
        tabs = tabs.concat (Object.keys (this.data.types.range || []));

        tabs = tabs.map (d => capitalize (d));

        tabs.sort ();

        return tabs;
      },

      timelineToSeries (key, counter) {
        let points = [];

        let i = 0;
        let parseTime = d3.timeParse ("W%UY%Y");

        forEach (counter.timeline, (average, timegroup) => {
          // let m = /W(\d+)Y(\d+)/.exec (timegroup);

          points.push ({
            // x: weekToDate (m [1], m [2]).getTime () / 1000,
            x: parseTime (timegroup).getTime () / 1000,
            y: Math.round (average.value)
          });
        });

        return [
          {
            label: capitalize (key),
            colour: 'red',
            points: points
          }
        ];
      },

      timelineFormatX (d) {
        return moment (d * 1000).format ('W/YY');
        // .format ('[W] MM/YY');
        // let date = new Date (d * 1000);
        // let tick = `${date.getMonth ()}/${('' + date.getFullYear ()).substr (2)}`;

        // return tick;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .Statistics {
    .Histogram,
    .LineChart {
       height: 400px;
    }

    &-Extrema {
      margin-top: 40px;
    }

    .Tabbed-horizontal {
      ul {
        li {
          font-size: 22px;
        }
      }
    }
  }
</style>